import i18n from "i18next";

/**
 * Case-insensitive + case-variant translation helper
 * @param {string} inputPhrase - e.g. "Import Shipment leads"
 * @returns {string} - translated string
 */
export function t(inputPhrase) {
    const translate = i18n.t;

    if (!inputPhrase || typeof inputPhrase !== "string") return "";

    // Transform variations
    const variations = generateVariations(inputPhrase);

    // 1. Try variations in order
    for (const v of variations) {
        const result = translate(v);
        if (result && result !== v) {
            return result;
        }
    }

    // 2. Try combinations word by word
    const words = inputPhrase.split(" ");
    const translatedParts = [];

    let i = 0;
    while (i < words.length) {
        let found = false;

        for (let j = words.length; j > i; j--) {
            const phrase = words.slice(i, j).join(" ");
            const variations = generateVariations(phrase);

            for (const v of variations) {
                const result = translate(v);
                if (result && result !== v) {
                    translatedParts.push(result);
                    i = j;
                    found = true;
                    break;
                }
            }

            if (found) break;
        }

        if (!found) {
            translatedParts.push(words[i]);
            i++;
        }
    }

    return translatedParts.join(" ");
}

/**
 * Generate possible case variations of a phrase
 * @param {string} str
 * @returns {string[]}
 */
function generateVariations(str) {
    const lower = str.toLowerCase();
    const upper = str.toUpperCase();
    const firstCapital = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    const firstLower = str.charAt(0).toLowerCase() + str.slice(1);
    const camelCase = str
        .toLowerCase()
        .split(" ")
        .map((w, i) => (i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)))
        .join("");

    return [str, firstCapital, camelCase, firstLower, upper, lower];
}
